const colors = {
  //colors
  IA_COLOR_00: '#FFFFFF',
  IA_COLOR_01: '#292F4F',
  IA_COLOR_02: '#3D4260',
  IA_COLOR_03: '#F2F2F2',
  IA_COLOR_04: '#4B566F',
  IA_COLOR_05: '#496CEC',
  IA_COLOR_06: '#212121',
  IA_COLOR_07: '#F5F6F7',
  IA_COLOR_08: '#CDCED6',
  IA_COLOR_09: '#70748A',
  IA_COLOR_10: '#9A9A9A',
  IA_COLOR_11: '#A9B2BD',
  IA_COLOR_12: '#6A6A6A',
  IA_COLOR_13: '#8AA7F5',
  IA_COLOR_14: '#E1E1E1',
  IA_COLOR_15: '#E9EAED',
  IA_COLOR_16: '#DA4453',
  IA_COLOR_17: '#4C7B67',
  IA_COLOR_18: '#B3E5FC',
  IA_COLOR_19: '#003C75',
  IA_COLOR_20: '#FFEBBA',
  IA_COLOR_21: '#765A20',
  IA_COLOR_22: '#F8BFC5',
  IA_COLOR_23: '#9A303B',

  // Not in krav but still used from IB.. check reqs for new mapping
  IA_COLOR_99: '#3C3C3C',
  IA_COLOR_98: '#99E5D2',
  IA_COLOR_97: '#355547',
};
export default colors;
